import { Component, Show } from "solid-js";
import { useLocation } from "@solidjs/router";
import { Heading, Text } from "~/components/typography";
import styles from "./HeroContentBlock.module.css";

export interface HeroContentBlockProps {
  title?: string;
  titleScale?: "large" | "medium" | "small";
  subtitle?: string;
  description?: string;
  imageUrl?: string;
  imageAlt?: string;
  compact?: boolean;
}

/**
 * HeroContentBlock Component
 *
 * Hero section for pages. Renders an optional title above a full-width cover image.
 */
const HeroContentBlock: Component<HeroContentBlockProps> = (props) => {
  const location = useLocation();
  const isHome = () => location.pathname === "/";

  return (
    <div class={isHome() ? styles.heroWrapper : undefined}>
      <div class={styles.heroContent} classList={{ [styles.heroContentCompact]: props.compact }}>
        <Show when={isHome() && props.title}>
          <div class={styles.header}>
            <Heading
              variant="pageTitleHome"
              classList={{
                [styles.titleMedium]: props.titleScale === "medium",
                [styles.titleSmall]: props.titleScale === "small",
              }}
            >
              {props.title}
            </Heading>
            <Show when={props.subtitle}>
              <Heading variant="pageSubline" as="h2">
                {props.subtitle}
              </Heading>
            </Show>
            <Show when={props.description}>
              <Text variant="bodyWhite">{props.description}</Text>
            </Show>
          </div>
        </Show>

        <Show when={props.imageUrl}>
          <div
            class={props.compact ? styles.cardCompact : styles.card}
            classList={{ [styles.cardHome]: isHome() && !props.compact }}
          >
            <img src={props.imageUrl} alt={props.imageAlt || props.title || ""} loading="eager" />
          </div>
        </Show>
      </div>
    </div>
  );
};

export default HeroContentBlock;
